var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"fill-height align-start"},[_c('userCard',{attrs:{"mode":'view',"user":_vm.user}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }